var render = function render(_c,_vm){return _c('div',[_c('el-tag',{attrs:{"type":_vm.$options.ColorType(_vm.props)}},[_vm._v(" "+_vm._s(_vm.$options.ValueStatus(_vm.props))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }